<app-entity-name-number-record
  [name]="name"
  [iconClass]="entityIcon"
  [numberFormatted]="entityNumberFormatted"
/>
